import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { TabContainerComponent } from './tab-container.component';
import { CollapseListModule } from '../../../../../../components/collapse-list/collapse-list.module';

@NgModule({
  declarations: [TabContainerComponent],
  imports: [CommonModule, I18nModule, CollapseListModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        TabContainer: {
          component: TabContainerComponent,
        },
      },
    }),
  ],
})
export class TabContainerModule {}
